import { Link } from "@tanstack/react-router";

export function Wordmark({ className = "" }: { className?: string }) {
  return (
    <Link to="/" className={`flex items-baseline font-bold tracking-tight text-foreground ${className}`}>
      <span className="text-primary">heall</span>
      <span>exa</span>
      <span className="ml-1 inline-block h-1.5 w-1.5 bg-primary translate-y-[-2px]" aria-hidden />
    </Link>
  );
}
